<template>
  <div ref="dropdown" :class="['dropdown', { active: isDropdownOpen }]">
    <div
      class="dropdown__selected-item"
      @click="isDropdownOpen = !isDropdownOpen"
    >
      <span class="dropdown__title">{{
        timeTitleTranslate(itemData.timeUnit)
      }}</span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6L8 10L4 6"
          stroke="#1A1D1B"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <ul v-if="isDropdownOpen" class="dropdown__list">
      <li
        v-for="(item, index) in TIME_UNIT"
        :key="index"
        :class="{ active: timeTitleTranslate(itemData.timeUnit) === item }"
        @click.stop="selectItem(item)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { addScopedEventListener } from "~/utils/eventListener";
import { usePowerCalcStore } from "~/store/powerCalcStore";

const powerCalcStore = usePowerCalcStore();

const props = defineProps({
  itemData: { type: Object, required: true },
});

const isDropdownOpen = ref(false);
const dropdown = ref(null);

const TIME_UNIT = [_T("@watch"), _T("@minutes")];

function timeTitleTranslate(val) {
  return val === "hours" ? _T("@watch") : _T("@minutes");
}

function selectItem(item) {
  isDropdownOpen.value = false;
  const timeTranslate = item === _T("@watch") ? "hours" : _T("@minutes");
  powerCalcStore.updateTimeUnit(props.itemData.index, timeTranslate);
}

function handleClickOutside(event) {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    isDropdownOpen.value = false;
  }
}

onMounted(() => {
  addScopedEventListener(window, "click", handleClickOutside);
});
</script>

<style lang="scss" scoped>
.dropdown {
  max-width: 135px;
  width: 100%;

  position: relative;

  cursor: pointer;

  border: 1px solid #e3e5e5;
  border-radius: 30px;

  &.active {
    .dropdown__selected-item {
      svg {
        transform: rotateZ(180deg);
      }
    }
  }

  @include bigMobile() {
    max-width: max-content;
  }

  &__selected-item {
    min-height: 42px;

    @include flex-container(row, space-between, center);

    gap: 8px;
    padding: 8px 16px;

    transition: border-color 0.1s ease-in-out;

    @include bigMobile() {
      min-height: 36px;
    }

    span {
      @include font(16, 22, 500);
      color: var(--color-grey-900);

      @include bigMobile() {
        @include font(14, 18, 500);
      }
    }

    svg {
      transition: transform 0.3s ease-in-out;
      transform: rotateZ(0);
    }
  }

  &__list {
    width: 100%;

    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 10;

    background-color: white;
    text-transform: lowercase;

    border: 1px solid var(--color-sky-light);
    border-radius: 24px;

    overflow: hidden;

    li {
      width: 100%;

      padding: 16px;

      @include bigMobile() {
        @include font(14, 18);
      }

      cursor: pointer;

      &.active {
        background-color: var(--color-primary-lightest);
      }
    }
  }
}
</style>
